<template>
	<footer class="site-footer">
		<span>&copy; 2026 Sentencing Pro, Inc. </span>
		<div>
			<small><time :datetime="buildDate" :title="buildDate">v.{{ build }}</time></small>
		</div>
	</footer>
</template>

<script>
const build = __BUILD__
const buildDate = __BUILD_DATE__

export default {
	name: 'SiteFooter',
	data: () => ({
		build,
		buildDate,
	})
}
</script>

<style scoped lang="scss">
.site-footer {
	background-color: rgba(255, 255, 255, 0.45);
	backdrop-filter: blur(10px);
	height: 4rem;
	display: flex;
	width: 100%;
	align-items: center;
	font-size: 0.95rem;
	justify-content: space-between;
	// border-top: 1px solid var(--color--border);
	// background-color: var(--color--background);
	padding: 0 1rem;
	margin-top: 2rem;
}
</style>
